
import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { name: '首页', href: '/' },
    { name: '产品', href: '#products' },
    { name: '科学', href: '#science' },
    { name: '关于我们', href: '/about' },
    { name: '社群', href: '#community' },
    { name: '联系方式', href: '#contact' }
  ];

  const handleNavClick = (href: string) => {
    if (href === '/') {
      // 首页导航逻辑
      if (window.location.pathname === '/') {
        // 已在首页，滚动到顶部
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        // 不在首页，跳转到首页
        window.REACT_APP_NAVIGATE('/');
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      }
      setIsMenuOpen(false);
    } else if (href.startsWith('#')) {
      // 检查当前页面是否有对应的锚点元素
      const element = document.querySelector(href);
      if (element) {
        // 当前页面有锚点，直接滚动
        element.scrollIntoView({ behavior: 'smooth' });
        setIsMenuOpen(false);
      } else {
        // 当前页面没有锚点，跳转到首页对应区域
        if (window.location.pathname !== '/') {
          // 不在首页，先跳转到首页再滚动到对应区域
          window.REACT_APP_NAVIGATE('/');
          setTimeout(() => {
            const targetElement = document.querySelector(href);
            if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
        }
        setIsMenuOpen(false);
      }
    } else {
      // 页面跳转
      window.REACT_APP_NAVIGATE(href);
      // 跳转后滚动到顶部
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="w-full bg-white/95 backdrop-blur-sm sticky top-0 z-50">
      <div className="mx-auto px-6 lg:px-32">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img 
              alt="燃轻元" 
              className="h-8 w-auto object-contain cursor-pointer hover:opacity-80 transition-opacity duration-200" 
              src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/58ab3c2c100cfeefc13e4dde60a3c9a8.png"
              onClick={() => window.REACT_APP_NAVIGATE('/')}
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-12">
            {navItems.map((item) => (
              <button
                key={item.name}
                onClick={() => handleNavClick(item.href)}
                className="text-gray-700 hover:text-[#847eba] transition-colors duration-300 text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                {item.name}
              </button>
            ))}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-[#847eba] transition-colors duration-300 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden pb-6">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <button
                  key={item.name}
                  onClick={() => handleNavClick(item.href)}
                  className="text-gray-700 hover:text-[#847eba] focus:text-[#847eba] focus:bg-[#847eba]/10 focus:outline-none focus:ring-2 focus:ring-[#847eba]/50 focus:ring-offset-2 transition-all duration-300 text-sm font-medium cursor-pointer text-left rounded-lg px-3 py-2"
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
